export default __webpack_public_path__ + "static/media/plain-sticker-y.c5b27a31.png";